import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-yeast-infection-prevention',
  templateUrl: './yeast-infection-prevention.component.html',
  imports: [UpsellCardComponent],
})
export class YeastInfectionPreventionComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.Fluconazole;
}
